import React, { useEffect } from "react";
import { Carousel, Spin } from "antd";
import { useData } from "../../contexts/DataContext";
import { fetchReviews } from "../../services/ApiService";
import ReviewCard from "./ReviewCard";
import "./ReviewCarousel.css";

const ReviewCarousel = () => {
  const { state, dispatch } = useData();

  useEffect(() => {
    // Check if pricing data has already been fetched
    if (!state.reviews) {
      // If pricing data hasn't been fetched, fetch it
      fetchReviews(dispatch);
    }
  }, [dispatch, state.reviews]);

  return (
    <div className="responsive-carousel">
      <div
        style={{
          backgroundColor: "burlywood",
          width: state.isMobile ? "60%" : "40%",
          height: "35px",
          display: "flex",
          marginTop: "10px",
          marginBottom: "40px",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <h3 style={{ paddingRight: "6%", color: "white" }}>Client Reviews</h3>
      </div>

      {state.reviews ? (
        <Carousel
          autoplay
          autoplaySpeed={state.isMobile ? 4500 : 8000}
          dots={true}
          slidesToShow={Math.floor(window.innerWidth / 350)}
        >
          {state.reviews.map((review, index) => (
            <div key={index} className="carousel-item">
              <ReviewCard review={review} />
            </div>
          ))}
        </Carousel>
      ) : (
        <Spin></Spin>
      )}
    </div>
  );
};

export default ReviewCarousel;
